const defaultState:boolean = false;
export default function get(state = defaultState, action:any) {
    switch (action.type) {
        case 'SET_LOADING':
            return action.value
        default:
            return state;
    }
}
